import { styled } from '@mui/material/styles';
import Button from '../Button/Button';

interface StyledButtonIconProps {
  position?: string;
  top?: string;
  right?: string;
  transform?: string;
}

const StyledButtonIcon = styled(Button)<StyledButtonIconProps>`
  font-weight: normal;
  font-size: 1.25rem;
  padding: 0.5rem;
  display: flex;
  gap: 0.5rem;
  width: fit-content;
  color: var(--primary-color);
  position: ${({ position }) => position || 'static'};
  top: ${({ top }) => top || 'auto'};
  right: ${({ right }) => right || 'auto'};
  transform: ${({ transform }) => transform || 'none'};
`;

export default StyledButtonIcon;
